export enum TaskStatus {
    Created,    // 0
    Started ,   // 1
    Completed , // 2
    Failed,     // 3
    Cancelling, // 4
    Cancelled   // 5
}